import React from 'react';
import { EditLabelForm } from './EditLabelForm';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalProps,
} from 'reactstrap';
import { Label, LabelUpdate } from '../../../models/api';

interface Props extends ModalProps {
    onConfirm: (labelUpdate: LabelUpdate) => void;
    label: Label | undefined;
}

export const EditLabelModal: React.FC<Props> = (props) => {
    const { isOpen, onClosed, label, onConfirm } = props;
    const formId = 'edit-label-form';
    return (
        <Modal isOpen={isOpen} toggle={onClosed}>
            <ModalHeader toggle={onClosed}>Edit Label</ModalHeader>
            <ModalBody>
                <EditLabelForm
                    label={label}
                    formId={formId}
                    onConfirm={onConfirm}
                />
            </ModalBody>
            <ModalFooter>
                <Button type="submit" color="success" form={formId}>
                    Save
                </Button>
            </ModalFooter>
        </Modal>
    );
};
